import { AxiosError, isAxiosError } from 'axios';

import { isAuthError } from './isAuthError';

export const isAxiosAuthError = (error: unknown): error is AxiosError => {
  return isAxiosError(error) && isAuthError(error.response?.status);
};
